import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {
    SimplePresentation,
    SimplePresentationRunner
} from "../../core/winpresentation/SimplePresentationRunner";
import {CollapsePresentation} from "../presentations/avalanche/CollapsePresentation";
import {HTHInitialWinPresentation} from "../presentations/HTHInitialWinPresentation";
import {HTHXWaysPresentation} from "../presentations/HTHXWaysPresentation";
import {HTHTotalWinCountupPresentation} from "../presentations/HTHTotalWinCountupPresentation";
import {HTHXSplitPresentation} from "../presentations/HTHXSplitPresentation";
import {HTHRemovalSymbolPresentation} from "../presentations/HTHRemovalSymbolPresentation";
import {HTHAvaSplitPresentation} from "../presentations/HTHAvaSplitPresentation";
import {HTHBigWinPresentation} from "../presentations/HTHBigWinPresentation";
import {HTHEnhancerUnlockedPresentation} from "../presentations/HTHEnhancerUnlockedPresentation";
import {HTHXNudgePresentation} from "../presentations/HTHXNudgePresentation";
import {HTHFSOutroPresentation} from "../presentations/freespin/HTHFSOutroPresentation";
import {HTHWinCapPresentation} from "../presentations/HTHWinCapPresentation";
import {HTHScatterCollectionPresentation} from "../presentations/freespin/HTHScatterCollectionPresentation";
import {SanityCheckPresentation} from "../presentations/SanityCheckPresentation";
import {HTHScatterWinPresentation} from "../presentations/maingame/HTHScatterWinPresentation";
import {HTHExtraSpinCountupSummary} from "../presentations/HTHExtraSpinCountupSummary";
import {HTHGodModeMaxWinPresentation} from "../presentations/HTHGodModeMaxWinPresentation";

export class HTHWinPresentation implements FlowStatePresentation {
    private presentations: SimplePresentation[];

    constructor() {
        this.presentations = [
            new HTHXWaysPresentation(),
            new HTHXSplitPresentation(),
            new HTHXNudgePresentation(),
            new HTHInitialWinPresentation(),//intial win + explode
            new HTHRemovalSymbolPresentation(),
            new HTHAvaSplitPresentation(),
            new CollapsePresentation(),
            new SanityCheckPresentation(),
            new HTHTotalWinCountupPresentation(),
            new HTHScatterCollectionPresentation(),
            new HTHGodModeMaxWinPresentation(),
            new HTHBigWinPresentation(),
            new HTHScatterWinPresentation(),
            new HTHExtraSpinCountupSummary(),
            new HTHFSOutroPresentation(),
            new HTHWinCapPresentation()
        ];
    }

    public start(flowStateController: FlowStateController) {
        SimplePresentationRunner.run(this.presentations, () => flowStateController.finish(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }
}